import { render, staticRenderFns } from "./copyWriter.vue?vue&type=template&id=1e55b121&scoped=true&"
import script from "./copyWriter.vue?vue&type=script&lang=js&"
export * from "./copyWriter.vue?vue&type=script&lang=js&"
import style0 from "./copyWriter.vue?vue&type=style&index=0&id=1e55b121&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e55b121",
  null
  
)

export default component.exports